
		<div class="admin">
			<h2>Crop type attribute admin (proto)</h2>

			<div *ngIf="!selected">
				<label class="filter">
					<input type="checkbox" [ngModel]="invalidOnly" (ngModelChange)="setInvalidOnly($event)" />
					Invalid only
				</label>
				<table>
					<thead><tr><th>Commodity</th><th>Status</th><th>Issues</th></tr></thead>
					<tbody>
						<tr *ngFor="let c of commodities" (click)="open(c.name)" class="click">
							<td>{{ c.name }}</td>
							<td [class.bad]="!c.valid">{{ c.valid ? 'Valid' : 'Invalid' }}</td>
							<td>{{ c.issueCount || '—' }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div *ngIf="selected">
				<button type="button" (click)="back()">← Commodities</button>
				<h3>{{ selected }}</h3>
				<table>
					<thead><tr><th>Crop type</th><th>Status</th><th>Attributes</th><th></th></tr></thead>
					<tbody>
						<ng-container *ngFor="let r of rows; trackBy: trackRow">
							<tr [class.bad]="r.issue !== 'ok'">
								<td>{{ r.crop.name }}</td>
								<td>{{ issueLabel(r.issue) }}</td>
								<td class="attrs">{{ r.summary }}</td>
								<td><button type="button" (click)="startEdit(r.crop.name)">Edit</button></td>
							</tr>
							<tr *ngIf="editingName === r.crop.name" class="edit">
								<td colspan="4">
									<label *ngFor="let k of attrKeys">
										{{ k }}
										<input
											[type]="k === 'bedWidth' || k === 'rows' ? 'number' : 'text'"
											[ngModel]="displayAttr(r.crop, k)"
											(ngModelChange)="setAttr(r.crop, k, $event)"
										/>
									</label>
									<button type="button" (click)="stopEdit()">Done</button>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>
			</div>
		</div>
	